import { createAction } from '@reduxjs/toolkit';
import { addNamespace } from '@Utils/actions';
import { Status } from '@innovyze/lib-am-common';
import {
	AssetBreakDownResponse,
	GetDeteriorationModelFailureGradeChartResponse,
	UpdateFailureGradeRangeRequest,
	UpdateMatrixGradeRequest,
} from '@Types';

export const getFailureGradeMatrixAction = createAction<{
	modelId: string | undefined;
	latestRunResultId: string | null;
}>(addNamespace('failureGrade/list'));

export const getFailureGradeMatrixResolved = createAction<
	GetDeteriorationModelFailureGradeChartResponse & { modelId: string; latestRunResultId: string | null }
>(addNamespace('failureGrade/listResolved'));

export const getFailureGradeMatrixRejected = createAction<Status>(addNamespace('failureGrade/listRejected'));

export const updateFailureGradeMatrixRanges = createAction<UpdateFailureGradeRangeRequest>(
	addNamespace('failureGrade/updateRanges'),
);

export const updateFailureGradeMatrixRangesResolved = createAction<
	GetDeteriorationModelFailureGradeChartResponse & { modelId: string }
>(addNamespace('failureGrade/updateRangesResolved'));

export const updateFailureGradeMatrixRangesRejected = createAction<Status>(
	addNamespace('failureGrade/updateRangesRejected'),
);

export const updateFailureMatrixGrade = createAction<UpdateMatrixGradeRequest>(
	addNamespace('failureGrade/updateGrade'),
);

export const updateFailureMatrixGradeResolved = createAction<
	GetDeteriorationModelFailureGradeChartResponse & { modelId: string }
>(addNamespace('failureGrade/updateGradeResolved'));

export const updateFailureMatrixGradeRejected = createAction<Status>(addNamespace('failureGrade/updateGradeRejected'));

// runResultsId is a required string, not optional or nullable: it is load-bearing as
// the cache key, and a null would be stored, never match a real run id, and silently
// defeat the staleness check.
export const getAssetBreakDownChartAction = createAction<{
	modelId: string | undefined;
	runResultsId: string;
}>(addNamespace('assetBreakDown/list'));

export const getAssetBreakDownChartResolved = createAction<
	AssetBreakDownResponse & { modelId: string; runResultsId: string }
>(addNamespace('assetBreakDown/listResolved'));

export const getAssetBreakDownChartRejected = createAction<Status>(addNamespace('assetBreakDown/listRejected'));
